import axios from "axios";
import { getRawToken, getToken } from "../utils/tokenFunctions";
import { baseApiURL, baseOASOrganizacion, baseOASTP, baseUrlNivelesMateriasObjetivos } from "./baseApiUrl";
import { iCompleteUser } from "../interfaces/Auth/iCompleteUser";
import { DataObjetivosPorNivel } from "../interfaces/DataObjetivosPorNivel";
import { environment } from "../config";
import { DataUserMinimalAPIPayload } from "../interfaces/DataUserMinimalAPIPayload";
import { DataResponseMinimalApi } from "../interfaces/DataResponseMinimalApi";
import { ApiBrokerResponseStructure, DataDefaultStructureResponse, DataDefaultStructureResponseBackend } from "../interfaces/DataDefaultStructureResponse";
import { OriginalAsignatura } from "../interfaces/ObjetivosAprendizaje/iAsignaturas";
import { apiClient } from "./apiClient";
import { AIRequestBody } from "../interfaces/Editor/AIRequestBody";
import { AIResponseLLM } from "../interfaces/Editor/AIResponseLLM";


/**
 * Obtiene datos del usuario
 */
export const getWhoami = async (): Promise<DataDefaultStructureResponseBackend<iCompleteUser>> => {
  try {
    const { data, status } = await apiClient.get('/who_am_i');
    return { data, status };
  } catch (error) {
    console.error(error);
    throw new Error("No se pudo conectar con el servicio getWhoami");
  }
};


export const getObjetivosAprendizajePorNivel = async (gradoId: number): Promise<DataDefaultStructureResponse<DataObjetivosPorNivel[]>> => {
  try {
    const { data, status } = await apiClient.get(`/objetivos?grado=${gradoId}`);
    return Object.assign({ data, status });
  } catch (error: any) {
    throw new Error("No es posible obtener información de los objetivos de aprendizaje" + error);
  }
};

/**
 *
 * @param {*} pregunta
 * @returns
 */

export const postChatSofia = async (payload: {
  usuario: any; // Información del usuario
  contenidos: {
    temperatura: number;
    modelID: number;
    prompt: string;
  };
}) => {
  try {
    const response = await apiClient.post('/ummiapedia', JSON.stringify(payload));
    return response;
  } catch (error: any) {
    throw new Error("No es posible enviar la pregunta al chat de Sofia: " + error.message);
  }
};

/**
 *
 * @returns
 */
export const get_abp_conf = async () => {
  try {
    const response = await apiClient.get('/get_abp_conf');
    const { data, status } = response;
    return Object.assign({ data, status });
  } catch (error: any) {
    console.error("get_abp_conf: Se produjo un error al realizar la solicitud a la API:" + error);
  }
};

/**
 *
 * @returns
 */
export const get_grados = async () => {
  try {
    const response = await apiClient.get('/get_grados');
    const { data, status } = response;
    return Object.assign({ data, status });
  } catch (error: any) {
    console.error("get_grados: Se produjo un error al realizar la solicitud a la API:" + error);
  }
};

/**
 *
 * @returns
 */
export const get_especialidades = async () => {
  try {
    const response = await apiClient.get(`${baseOASTP}/especialidades`);
    const { data, status } = response;
    return Object.assign({ data, status });
  } catch (error: any) {
    console.error("get_especialidades: Se produjo un error al realizar la solicitud a la API:" + error);
  }
};

/**
 *
 * @returns
 */
export const get_niveles_tp = async (especialidadId: string) => {
  try {
    const response = await apiClient.get(
      `${baseOASTP}/especialidades/${especialidadId}/niveles`
    );
    const { data, status } = response;
    return { data, status };
  } catch (error: any) {
    console.error(
      "get_niveles_tp: Se produjo un error al realizar la solicitud a la API:",
      error
    );
    return { data: null, status: 0, error };
  }
};

/**
 *
 * @returns
 */
export const get_niveles_organizacion = async (organizacionId: string) => {
  try {
    const response = await apiClient.get(
      `${baseOASOrganizacion}/nivel/organizacion/${organizacionId}`
    );
    const { data, status } = response;
    return { data, status };
  } catch (error: any) {
    console.error(
      "get_niveles_organizacion: Se produjo un error al realizar la solicitud a la API:",
      error
    );
    return { data: null, status: 0, error };
  }
};

/**
 *
 * @returns
 */


export const get_asignaturas_organizacion = async (nivelId: string) => {
  try {
    const response = await apiClient.get(
      `${baseOASOrganizacion}/nivel-asignatura/${nivelId}`
    );
    const { data, status } = response;
    return { data, status };
  } catch (error: any) {
    console.error(
      "get_asignaturas_organizacion: Se produjo un error al realizar la solicitud a la API:",
      error
    );
    return { data: null, status: 0, error };
  }
};

/**
 *
 * @returns
 */
export const get_asignaturas_tp = async (especialidadId: string, nivelId: string) => {
  try {
    const response = await apiClient.get(
      `${baseOASTP}/especialidades/${especialidadId}/niveles/${nivelId}/asignaturas`
    );
    const { data, status } = response;
    return { data, status };
  } catch (error: any) {
    console.error(
      "get_asignaturas_tp: Se produjo un error al realizar la solicitud a la API:",
      error
    );
    return { data: null, status: 0, error };
  }
};

/**
 *
 * @returns
 */
export const get_objetivos_aprendizaje_organizacion = async (id_nivel_asignatura: string) => {
  try {
    const response = await apiClient.get(
      `${baseOASOrganizacion}/nivel-asignatura/${id_nivel_asignatura}/objetivos`
    );
    const { data, status } = response;
    return { data, status };
  } catch (error: any) {
    console.error(
      "get_objetivos_aprendizaje_organizacion: Se produjo un error al realizar la solicitud a la API:",
      error
    );
    return { data: null, status: 0, error };
  }
};

export const get_indicadores_organizacion = async (idObjetivo: string) => {
  try {
    const response = await apiClient.get(
      `${baseOASOrganizacion}/indicador/objetivo/${idObjetivo}`
    );
    const { data, status } = response;
    return { data, status };
  } catch (error: any) {
    console.error(
      "get_indicadores_organizacion: Se produjo un error al realizar la solicitud a la API:",
      error
    );
    return { data: null, status: 0, error };
  }
};

/**
 *
 * @returns
 */
export const get_objetivos_aprendizaje_tp = async (asignaturaId: string, nivelId: string) => {
  try {
    const response = await apiClient.get(
      `${baseOASTP}/niveles/${nivelId}/asignaturas/${asignaturaId}/objetivos-aprendizaje`
    );
    const { data, status } = response;
    return { data, status };
  } catch (error: any) {
    console.error(
      "get_objetivos_aprendizaje_tp: Se produjo un error al realizar la solicitud a la API:",
      error
    );
    return { data: null, status: 0, error };
  }
};

/**
 *
 * @returns
 */
export const get_aprendizajes_esperados_tp = async (objetivoAprendizajeId: string) => {
  try {
    const response = await apiClient.get(
      `${baseOASTP}/objetivos-aprendizaje/${objetivoAprendizajeId}/aprendizajes-esperados`
    );
    const { data, status } = response;
    return { data, status };
  } catch (error: any) {
    console.error(
      "get_aprendizajes_esperados_tp: Se produjo un error al realizar la solicitud a la API:",
      error
    );
    return { data: null, status: 0, error };
  }
};

/**
 *
 * @returns
 */
export const get_criterios_evaluacion_tp = async (aprendizajeEsperadoId: string) => {
  try {
    const response = await apiClient.get(
      `${baseOASTP}/aprendizajes-esperados/${aprendizajeEsperadoId}/criterios-evaluacion`
    );
    const { data, status } = response;
    return { data, status };
  } catch (error: any) {
    console.error(
      "get_criterios_evaluacion_tp: Se produjo un error al realizar la solicitud a la API:",
      error
    );
    return { data: null, status: 0, error };
  }
};

/**
 *
 * @returns
 */
export const get_objetivos_genericos_tp = async (criterioEvaluacionId: string) => {
  try {
    const response = await apiClient.get(
      `${baseOASTP}/criterios-evaluacion/${criterioEvaluacionId}/objetivos-genericos`
    );
    const { data, status } = response;
    return { data, status };
  } catch (error: any) {
    console.error(
      "get_objetivos_genericos_tp: Se produjo un error al realizar la solicitud a la API:",
      error
    );
    return { data: null, status: 0, error };
  }
};

/**
 *
 * @returns
 */
export const get_niveles = async (pais: any) => {
  try {
    const response = await axios.get(`${baseUrlNivelesMateriasObjetivos}/niveles?pais=${pais}`);
    const { data, status } = response;
    return { data, status };
  } catch (error) {
    console.error("get_niveles: Se produjo un error al realizar la solicitud a la API:", error);
  }
};

/**
 *
 * @returns
 */
export const get_materias = async () => {
  try {
    const response = await apiClient.get('/get_materias');
    const { data, status } = response;
    return Object.assign({ data, status });
  } catch (error: any) {
    console.error("get_materias: Se produjo un error al realizar la solicitud a la API:" + error);
  }
};

/**
 *
 * @returns
 */
export const get_asignaturas = async (pais: string, nivelId: string): Promise<ApiBrokerResponseStructure<OriginalAsignatura[]>> => {
  try {
    // Se arma la URL con los parámetros "pais" y "nivel"
    const response = await axios.get(`${baseUrlNivelesMateriasObjetivos}/asignaturas?pais=${pais}&nivel=${nivelId}`);
    const { data, status } = response;
    return { data, status };
  } catch (error) {
    console.error("get_asignaturas: Se produjo un error al realizar la solicitud a la API:", error);
    throw error;
  }
};

/**
 *
 * @returns
 */
export const get_modelos = async () => {
  try {
    const response = await apiClient.get('/get_modelos');
    const { data, status } = response;
    return Object.assign({ data, status });
  } catch (error: any) {
    console.error("get_modelos: Se produjo un error al realizar la solicitud a la API:" + error);
  }
};

/**
 *
 * @returns
 */
export const get_ODS = async () => {
  try {
    const response = await apiClient.get('/get_ODS');
    const { data, status } = response;
    return Object.assign({ data, status });
  } catch (error: any) {
    console.error("get_ODS: Se produjo un error al realizar la solicitud a la API:" + error);
  }
};

/**
 *
 * @returns
 */
export const get_objetivos = async () => {
  try {
    const response = await apiClient.get('/objetivos');
    const { data, status } = response;
    return Object.assign({ data, status });
  } catch (error: any) {
    console.error("get_objetivos: Se produjo un error al realizar la solicitud a la API:" + error);
  }
};

/**
 *
 * @param {*} promptData
 * @returns
 */
export const post_sandbox = async (promptData: any) => {
  try {
    const response = await apiClient.post('/sandbox', promptData);
    const { data, status } = response;
    return Object.assign({ data, status });
  } catch (error: any) {
    console.error("post_sandbox: Se produjo un error al realizar la solicitud a la API:" + error);
  }
};

export const post_story_telling = async (Titulo_ST: string, Story_Telling: string) => {
  try {
    const response = await apiClient.post('/crear_video_story_telling', {
      Titulo_ST,
      Story_Telling,
    });
    const { data, status } = response;
    return Object.assign({ data, status });
  } catch (error: any) {
    console.error("post_story_telling: Se produjo un error al realizar la solicitud a la API:" + error);
  }
};

export const post_crear_proyecto_etapa_1 = async (proyecto: any) => {
  try {
    const response = await apiClient.post('/crear_proyecto_etapa_1', proyecto);
    const { data, status } = response;
    return Object.assign({ data, status });
  } catch (error: any) {
    console.error("post_crear_proyecto_etapa_1: Se produjo un error al realizar la solicitud a la API:" + error);
  }
};

export const post_minimal_api = async (payload: DataUserMinimalAPIPayload): Promise<DataDefaultStructureResponseBackend<DataResponseMinimalApi>> => {
  try {
    console.log("post_minimal_api payload", payload);
    const config = {
      timeout: 120000, // 120 segundos
    };
    const response = await apiClient.post('/minimal_api', payload, config);
    const { data, status } = response;
    return Object.assign({ data, status });
  } catch (error: any) {
    throw new Error("post_minimal_api: Se produjo un error al realizar la solicitud a la API:" + error);
  }
};

export const post_api_mm = async (payload: DataUserMinimalAPIPayload): Promise<DataDefaultStructureResponseBackend<DataResponseMinimalApi>> => {
  try {
    console.log("post_api_mm payload", payload);
    const config = {
      timeout: 120000, // 120 segundos
    };
    const response = await apiClient.post('/api_mm', payload, config);
    const { data, status } = response;
    return Object.assign({ data, status });
  } catch (error: any) {
    throw new Error("post_api_mm: Se produjo un error al realizar la solicitud a la API:" + error);
  }
};

export const post_reformular_proyecto = async (body: AIRequestBody): Promise<DataDefaultStructureResponseBackend<AIResponseLLM>> => {
  try {
    const response = await apiClient.post('/instruction', body);
    console.log("post_reformular_proyecto response", response);
    const { data, status } = response;
    return Object.assign({ data, status });
  } catch (error: any) {
    console.error("post_reformular_proyecto: Se produjo un error al realizar la solicitud a la API:" + error);
    throw new Error("post_reformular_proyecto: Se produjo un error al realizar la solicitud a la API: " + error);
  }
};
export const post_escribir_instruccion = async (body: AIRequestBody): Promise<DataDefaultStructureResponseBackend<AIResponseLLM>> => {
  try {
    const response = await apiClient.post('/editar', body);
    console.log("post_escribir_instruccion response", response);
    const { data, status } = response;
    return Object.assign({ data, status });
  } catch (error: any) {
    console.error("post_escribir_instruccion: Se produjo un error al realizar la solicitud a la API:" + error);
    throw new Error("post_escribir_instruccion: Se produjo un error al realizar la solicitud a la API: " + error);
  }
};